import type { MouseEvent } from 'react';
import { CloseIcon } from '@/components/ui';

interface WorkspaceTabProps {
  label: string;
  active: boolean;
  onActivate: () => void;
  onClose: () => void;
  onHoverStart?: () => void;
  onHoverEnd?: () => void;
}

export function WorkspaceTab({
  label,
  active,
  onActivate,
  onClose,
  onHoverStart,
  onHoverEnd,
}: WorkspaceTabProps) {
  const handleClose = (e: MouseEvent) => {
    e.stopPropagation();
    onClose();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onActivate();
    }
  };

  return (
    <div
      role="tab"
      aria-selected={active}
      tabIndex={0}
      onClick={onActivate}
      onKeyDown={handleKeyDown}
      onMouseEnter={onHoverStart}
      onMouseLeave={onHoverEnd}
      onFocus={onHoverStart}
      onBlur={onHoverEnd}
      className={`group/wtab inline-flex items-center gap-2 h-7 pl-3 pr-2 rounded-lg border cursor-pointer select-none shrink-0 transition-colors ${
        active
          ? 'bg-primary-1 border-primary-6'
          : 'bg-white border-neutral-100 hover:bg-neutral-50'
      }`}
    >
      <span className="font-roboto text-xs leading-4 font-medium whitespace-nowrap text-neutral-n700">
        {label}
      </span>
      <button
        type="button"
        onClick={handleClose}
        aria-label={`Close ${label}`}
        className="w-4 h-4 inline-flex items-center justify-center rounded text-neutral-400 hover:text-neutral-700 hover:bg-neutral-100 transition-colors shrink-0"
      >
        <CloseIcon size={12} />
      </button>
    </div>
  );
}
